export default __webpack_public_path__ + "static/media/Churchpad-white-1024x258_2126f0f0f97a24c2e1c47ba5e98c3e33.1c214b69.png";